/* PowerPulse — comportamento da loja (código próprio; substitui os scripts do tema Sugar).
   1) Comprar: o aparelho + os brindes que ainda não estão no carrinho, num pedido só, e vai direto ao checkout.
   2) Barra fixa de compra: aparece quando o botão principal sai da tela e compra pelo mesmo caminho. */
(function () {
  var GIFTS = [67611200553328, 67611200586096];
  var GIFT_PROPS = { _vc_free_gift: '1' };

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return { items: [] }; });
  }

  function buy(form, btn) {
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return false;
    var qty = form.querySelector('[name="quantity"]');
    var main = { id: Number(idInput.value), quantity: parseInt(qty && qty.value, 10) || 1 };
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    getCart()
      .then(function (cart) {
        var have = {};
        (cart.items || []).forEach(function (it) { have[it.variant_id] = true; });
        var gifts = GIFTS.filter(function (id) { return !have[id]; })
          .map(function (id) { return { id: id, quantity: 1, properties: GIFT_PROPS }; });
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: gifts.reverse().concat([main]) })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('add'); window.location.href = '/checkout'; })
      .catch(function () { form.submit(); }); // nunca travar a venda: envio normal do formulário
    return true;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (form.dataset.ppBusy) return;
    form.dataset.ppBusy = '1';
    if (!addAndOpen(form, form.querySelector('[type="submit"]'))) { delete form.dataset.ppBusy; form.submit(); }
  }, true);

  // ---- carrinho lateral (08/10): o botão principal abre o carrinho com a garantia opcional (desligada) e o ThermaWave "most men run both" ----
  var BUMP = 67670287286640, SPRAY = 67790119174512, BUMP_PRICE = 10990, SPRAY_PRICE = 4988;
  var SPRAY_IMG = 'https://cdn.shopify.com/s/files/1/1041/1907/5184/files/real-spray_6e8a04e1-af61-46fe-8a5a-0c9e36c29b93.jpg?v=1792509344', BUMP_IMG = 'https://cdn.shopify.com/s/files/1/1041/1907/5184/files/thermawave_d36c7180-aadd-403a-b8d4-2eb78969da57.png?v=1791485335';
  var DEVICES = [67611194261872, 67670268871024];
  var COMPARE = { 67611194261872: 23980, 67670268871024: 73300, 67611200553328: 6499, 67611200586096: 3499, 67790119174512: 8990, 67670287286640: 17980 };
  var JSONH = { 'Content-Type': 'application/json', Accept: 'application/json' };
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function post(url, body) { return fetch(url, { method: 'POST', headers: JSONH, body: JSON.stringify(body) }).then(function (r) { if (!r.ok) throw new Error(url); return r.json(); }); }

  function addAndOpen(form, btn) {
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return false;
    var main = Number(idInput.value);
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    getCart()
      .then(function (cart) {
        var have = {};
        (cart.items || []).forEach(function (it) { have[it.variant_id] = true; });
        var hasDevice = DEVICES.some(function (id) { return have[id]; });
        var items = GIFTS.filter(function (id) { return !have[id]; })
          .map(function (id) { return { id: id, quantity: 1, properties: GIFT_PROPS }; }).reverse();
        if (!hasDevice) items.push({ id: main, quantity: 1 });
        return items.length ? post('/cart/add.js', { items: items }) : null;
      })
      .then(function () { return openDrawer(); })
      .catch(function () { window.location.href = '/checkout'; })
      .then(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); } delete form.dataset.ppBusy; });
    return true;
  }

  var CSS = [
    '.ppc{position:fixed;inset:0;z-index:2147483000;visibility:hidden;pointer-events:none}',
    '.ppc.is-open{visibility:visible;pointer-events:auto}',
    '.ppc__ov{position:absolute;inset:0;background:rgba(0,0,0,.6);opacity:0;transition:opacity .25s}',
    '.ppc.is-open .ppc__ov{opacity:1}',
    '.ppc__p{position:absolute;top:0;right:0;bottom:0;width:min(420px,92vw);background:#161618;color:#f2f0eb;display:flex;flex-direction:column;transform:translateX(100%);transition:transform .3s cubic-bezier(.2,.8,.2,1);box-shadow:-10px 0 40px rgba(0,0,0,.5);font-family:var(--font-body-family)}',
    '.ppc.is-open .ppc__p{transform:none}',
    '.ppc__hd{display:flex;align-items:center;justify-content:space-between;padding:16px 18px 10px}',
    '.ppc__hd h2{margin:0;font-family:var(--font-heading-family);font-size:24px;font-weight:800;letter-spacing:.02em;text-transform:uppercase;color:#fff}',
    '.ppc__x{background:none;border:0;color:#f2f0eb;font-size:30px;line-height:1;cursor:pointer;padding:0 4px}',
    '.ppc__ship{padding:0 18px 12px;text-align:center;font-size:13.5px;font-weight:700}',
    '.ppc__bar{display:block;margin-top:7px;height:8px;border-radius:5px;background:repeating-linear-gradient(135deg,#c8102e 0 8px,#e2253f 8px 16px)}',
    '.ppc__body{flex:1;overflow-y:auto;padding:0 18px 12px;border-top:1px solid #2c2c31}',
    '.ppc__ln{display:flex;gap:12px;padding:14px 0;border-bottom:1px solid #2c2c31;align-items:center}',
    '.ppc__img{flex:0 0 62px;width:62px;height:62px;border-radius:9px;overflow:hidden;background:#222}',
    '.ppc__img img{width:100%;height:100%;object-fit:cover;display:block}',
    '.ppc__i{flex:1;min-width:0}',
    '.ppc__t{font-weight:800;font-size:14.5px;line-height:1.2;color:#fff}',
    '.ppc__d{font-size:12px;color:#a9a6a0;line-height:1.3;margin-top:3px}',
    '.ppc__pr{text-align:right;white-space:nowrap;font-weight:800;font-size:14.5px}',
    '.ppc__pr s{display:block;color:#7d7a76;font-weight:500;font-size:12px}',
    '.ppc__free{color:#3ec46d}',
    '.ppc__rm{background:none;border:0;color:#7d7a76;cursor:pointer;font-size:12px;text-decoration:underline;padding:4px 0 0}',
    '.ppc__sw{position:relative;flex:0 0 46px;width:46px;height:26px;border-radius:14px;background:#3a3a40;border:0;cursor:pointer;transition:background .2s}',
    '.ppc__sw::after{content:"";position:absolute;top:3px;left:3px;width:20px;height:20px;border-radius:50%;background:#fff;transition:transform .2s}',
    '.ppc__sw[aria-checked=true]{background:#3ec46d}',
    '.ppc__sw[aria-checked=true]::after{transform:translateX(20px)}',
    '.ppc__bump{margin:16px 0 4px;padding:2px;border-radius:14px;background:linear-gradient(135deg,#f6d27a,#a9772a 35%,#f3cf73 60%,#8a5d1c)}',
    '.ppc__bin{border-radius:12px;background:radial-gradient(120% 80% at 50% 0%,#2a2113,#131210 60%);padding:12px}',
    '.ppc__badge{display:inline-block;font-family:"JetBrains Mono",Menlo,monospace;font-size:10px;font-weight:700;letter-spacing:.1em;color:#111;background:linear-gradient(135deg,#f6d27a,#c8963b);border-radius:5px;padding:3px 7px;margin-bottom:9px}',
    '.ppc__brow{display:flex;gap:11px;align-items:flex-start}',
    '.ppc__brow .ppc__img{flex-basis:74px;width:74px;height:74px;border:1px solid rgba(230,190,98,.4)}',
    '.ppc__bt{font-family:var(--font-heading-family);font-size:17px;font-weight:800;line-height:1.15;color:#fff;text-transform:uppercase}',
    '.ppc__bd{font-size:12.5px;line-height:1.35;color:#e4e1da;margin-top:4px}',
    '.ppc__bp{margin:9px 0 10px;font-weight:800;font-size:15px}',
    '.ppc__bp s{color:#7d7a76;font-weight:500;margin-right:6px}',
    '.ppc__sp{border-radius:12px;border:1px solid rgba(226,37,63,.45);background:rgba(226,37,63,.07);padding:12px 10px;margin:14px 0 0}',
    '.ppc__sp .ppc__pr{display:flex;flex-direction:column;align-items:flex-end}',
    '.ppc__sadd{margin-top:7px;border:0;border-radius:8px;cursor:pointer;padding:8px 14px;font-weight:800;font-size:13px;letter-spacing:.02em;color:#fff;background:linear-gradient(180deg,#e2253f,#b20d27)}',
    '.ppc__badd{margin-top:12px;width:100%;min-height:44px;border:0;border-radius:9px;cursor:pointer;font-weight:800;font-size:14px;letter-spacing:.02em;color:#111;background:linear-gradient(135deg,#f6d27a,#d9a748 55%,#f3cf73)}',
    '.ppc__ft{padding:12px 18px 16px;border-top:1px solid #2c2c31;background:#131315}',
    '.ppc__row{display:flex;justify-content:space-between;font-weight:800;font-size:14px;margin-bottom:4px}',
    '.ppc__row--sv{color:#3ec46d}',
    '.ppc__row--tot{font-size:19px;font-family:var(--font-heading-family);text-transform:uppercase;margin:6px 0 12px}',
    '.ppc__co{display:block;width:100%;min-height:56px;border:0;border-radius:12px;cursor:pointer;background:linear-gradient(180deg,#e2253f,#b20d27);color:#fff;font-family:var(--font-heading-family);font-weight:800;font-size:20px;letter-spacing:.04em;text-transform:uppercase;box-shadow:0 4px 0 #7a0819}',
    '.ppc__co.loading{opacity:.7}',
    '.ppc__safe{text-align:center;font-size:11.5px;color:#a9a6a0;margin-top:9px}',
    '.ppc__busy .ppc__body,.ppc__busy .ppc__ft{opacity:.55;pointer-events:none}'
  ].join('');

  var root;
  function ensure() {
    if (root) return root;
    var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);
    root = document.createElement('div');
    root.className = 'ppc'; root.setAttribute('aria-hidden', 'true');
    root.innerHTML = '<div class="ppc__ov" data-ppc-close></div><aside class="ppc__p" role="dialog" aria-modal="true" aria-label="Cart"></aside>';
    document.body.appendChild(root);
    root.addEventListener('click', onClick);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    return root;
  }
  function closeDrawer() { if (!root) return; root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
  function openDrawer() {
    ensure();
    return getCart().then(function (cart) {
      render(cart);
      root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden';
    });
  }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(src) { return '<div class="ppc__img">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : '') + '</div>'; }
  function small(url) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160' : ''; }

  function render(cart) {
    var p = root.querySelector('.ppc__p');
    var rank = function (it) { return DEVICES.indexOf(it.variant_id) > -1 ? 0 : (it.variant_id === BUMP || it.variant_id === SPRAY) ? 1 : it.final_line_price === 0 ? 2 : 3; };
    var items = (cart.items || []).slice().sort(function (x, y) { return rank(x) - rank(y); });
    if (!items.length) { closeDrawer(); return; }
    var lines = '', spray = null, bump = null, saved = 0, count = 0;
    items.forEach(function (it) {
      var cmp = COMPARE[it.variant_id];
      if (cmp) saved += Math.max(0, cmp * it.quantity - it.final_line_price);
      if (it.variant_id === SPRAY) spray = it;
      if (it.variant_id === BUMP) bump = it;
      count += it.quantity;
      var gift = it.final_line_price === 0;
      var isDevice = DEVICES.indexOf(it.variant_id) > -1;
      var right = gift
        ? '<div class="ppc__pr">' + (cmp ? '<s>' + money(cmp) + '</s>' : '') + '<span class="ppc__free">FREE</span></div>'
        : '<div class="ppc__pr">' + (cmp ? '<s>' + money(cmp * it.quantity) + '</s>' : '') + money(it.final_line_price) + '</div>';
      lines += '<div class="ppc__ln">' + img(small(it.image)) + '<div class="ppc__i"><div class="ppc__t">' + esc(it.product_title) + (it.quantity > 1 ? ' × ' + it.quantity : '') + '</div>' +
        (gift ? '<div class="ppc__d">Free bonus with your order</div>'
              : '<button type="button" class="ppc__rm" data-ppc-rm="' + esc(it.key) + '"' + (isDevice ? ' data-ppc-all="1"' : '') + '>Remove</button>') +
        '</div>' + right + '</div>';
    });
    if (!spray) {
      lines += '<div class="ppc__ln ppc__sp">' + img(small(SPRAY_IMG)) + '<div class="ppc__i"><div class="ppc__t">PrimePulse\u2122 Delay Spray</div>' +
        '<div class="ppc__d">Now it stays hard. Make it LAST. Ships in the same box. One-time, no refills.</div></div>' +
        '<div class="ppc__pr"><s>' + money(COMPARE[SPRAY]) + '</s>' + money(SPRAY_PRICE) +
        '<button type="button" class="ppc__sadd" data-ppc-spray>+ Add</button></div></div>';
    }
    if (!bump) {
      lines += '<div class="ppc__bump"><div class="ppc__bin"><span class="ppc__badge">MOST MEN RUN BOTH</span><div class="ppc__brow">' +
        img(small(BUMP_IMG)) + '<div><div class="ppc__bt">Add ThermaWave · Size &amp; Fullness</div>' +
        '<div class="ppc__bd">PrimePulse gets you hard. ThermaWave makes it fuller and thicker. PrimePulse on session days, ThermaWave in between.</div></div></div>' +
        '<div class="ppc__bp"><s>' + money(COMPARE[BUMP]) + '</s>' + money(BUMP_PRICE) + '</div>' +
        '<button type="button" class="ppc__badd" data-ppc-bump>Add ThermaWave to Cart</button></div></div>';
    }
    p.innerHTML =
      '<div class="ppc__hd"><h2>Cart · ' + count + ' item' + (count === 1 ? '' : 's') + '</h2><button type="button" class="ppc__x" aria-label="Close" data-ppc-close>&times;</button></div>' +
      '<div class="ppc__ship">Congrats! You get FREE shipping!<div class="ppc__bar"><span></span></div></div>' +
      '<div class="ppc__body">' + lines + '</div>' +
      '<div class="ppc__ft">' + (saved ? '<div class="ppc__row ppc__row--sv"><span>You saved</span><span>-' + money(saved) + '</span></div>' : '') +
      '<div class="ppc__row ppc__row--tot"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
      '<button type="button" class="ppc__co" data-ppc-checkout>Secure Checkout</button>' +
      '<div class="ppc__safe">🔒 Secure, encrypted checkout · 90-day money-back guarantee</div></div>';
  }

  function busy(on) { root.querySelector('.ppc__p').classList.toggle('ppc__busy', on); }
  function refresh(promise) { busy(true); return promise.then(getCart).then(render).catch(function () {}).then(function () { busy(false); }); }

  function onClick(e) {
    var t = e.target.closest('[data-ppc-close],[data-ppc-checkout],[data-ppc-spray],[data-ppc-bump],[data-ppc-rm]');
    if (!t) return;
    e.preventDefault();
    if (t.hasAttribute('data-ppc-close')) return closeDrawer();
    if (t.hasAttribute('data-ppc-checkout')) { t.classList.add('loading'); window.location.href = '/checkout'; return; }
    if (t.hasAttribute('data-ppc-spray')) return refresh(post('/cart/add.js', { items: [{ id: SPRAY, quantity: 1 }] }));
    if (t.hasAttribute('data-ppc-bump')) return refresh(post('/cart/add.js', { items: [{ id: BUMP, quantity: 1 }] }));
    if (t.hasAttribute('data-ppc-rm')) {
      if (t.hasAttribute('data-ppc-all')) return refresh(post('/cart/clear.js', {}));
      return refresh(post('/cart/change.js', { id: t.getAttribute('data-ppc-rm'), quantity: 0 }));
    }
  }

  // ---- upgrade para o Elite (card #pp-elite-upgrade): tira o aparelho do carrinho, põe o Elite + brindes e vai ao checkout ----
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pp-upgrade]');
    if (!btn) return;
    e.preventDefault();
    if (btn.dataset.ppBusy) return;
    btn.dataset.ppBusy = '1'; btn.classList.add('loading');
    var elite = Number(btn.getAttribute('data-pp-upgrade'));
    var replace = Number(btn.getAttribute('data-pp-replace'));
    getCart()
      .then(function (cart) {
        var updates = {}, have = {};
        (cart.items || []).forEach(function (it) {
          if (it.variant_id === replace) updates[it.key] = 0; else have[it.variant_id] = true;
        });
        var clear = Object.keys(updates).length
          ? fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
          : Promise.resolve();
        return clear.then(function () {
          var gifts = GIFTS.filter(function (id) { return !have[id]; })
            .map(function (id) { return { id: id, quantity: 1, properties: GIFT_PROPS }; });
          var items = have[elite] ? gifts.reverse() : gifts.reverse().concat([{ id: elite, quantity: 1 }]);
          return items.length ? fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) }) : { ok: true };
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('add'); window.location.href = '/checkout'; })
      .catch(function () { window.location.href = '/cart/' + elite + ':1'; }); // nunca travar a venda
  });

  // ---- barra fixa ----
  function mainForm() { return document.querySelector('form[action*="/cart/add"][id^="product-form-"]') || document.querySelector('form[action*="/cart/add"]'); }
  function bars() { return document.querySelectorAll('[class*="sticky-product-desktop--"], [class*="sticky-product-mobile--"]'); }

  // O botão principal pode ser recriado depois da carga (Alpine), então a posição é lida a cada rolagem,
  // sempre no botão atual — nunca guardando a referência de um elemento que pode sumir.
  function initSticky() {
    var list = bars();
    if (!list.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      var form = mainForm();
      var t = form && form.querySelector('[type="submit"]');
      var v = !!t && t.getBoundingClientRect().bottom < 0;
      list.forEach(function (b) { b.classList.toggle('is-visible', v); });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
    list.forEach(function (b) {
      b.addEventListener('click', function (e) {
        var btn = e.target.closest('button, [type="submit"], a[href*="cart"]');
        if (!btn || btn.closest('select')) return;
        e.preventDefault();
        var form = mainForm();
        if (!form) return;
        buy(form, btn); // barra fixa: direto ao checkout
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky); else initSticky();

  // ---- texturas de fundo (Como funciona, Linha do tempo) só baixam quando a seção chega perto da tela ----
  function initLazyBg() {
    var els = document.querySelectorAll('.vcmx, .vctl');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('pp-near'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('pp-near'); io.unobserve(en.target); } });
    }, { rootMargin: '1500px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLazyBg); else initLazyBg();
})();
